// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__-uYfl","head":"ProcedureTableInfo_head__1yEov"};